export const CREATE_SUBJECT = 'subject/CREATE_SUBJECT';
export const GET_SUBJECTS = 'subject/GET_SUBJECTS';
